<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "MediaGroupArchiveWrapper"
    }
</script>

<style scoped>

</style>